import { render, staticRenderFns } from "./SamCheckbox.vue?vue&type=template&id=e712a96c&scoped=true&"
import script from "./SamCheckbox.vue?vue&type=script&lang=js&"
export * from "./SamCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SamCheckbox.vue?vue&type=style&index=0&id=e712a96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e712a96c",
  null
  
)

export default component.exports